import HeroCarousel from '~/components/HeroCarousel';
import TrustSignals from '~/components/TrustSignals';
import MyData from '~/components/MyData';
import PropositionPart from '~/components/PropositionPart';
import Products from '~/components/Products';
import SolutionsPart from '~/components/SolutionsPart';
import Cases from '~/components/Cases';
import BottomTryBar from '~/components/BottomTryBar';

import './index.less';

function Home(): JSX.Element {
  return (
    <main className="main-content">
      <HeroCarousel />
      <TrustSignals />
      <MyData />
      <PropositionPart />
      <Products />
      <SolutionsPart />
      <Cases />
      <BottomTryBar />
    </main>
  );
}

export default Home;
